import { render } from "./PlayerSalary.vue?vue&type=template&id=6e30e5e2&scoped=true"
import script from "./PlayerSalary.vue?vue&type=script&lang=js"
export * from "./PlayerSalary.vue?vue&type=script&lang=js"

import exportComponent from "E:\\LEIGH_STORE\\PROJECTS\\2-PROJECTS\\6-PIYOOK\\ICS-Digital\\1-Dominic-Projects\\7-football-earnings\\5-website\\footy-earnings\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e30e5e2"]])

export default __exports__